import { SidebarMenuItem } from '@ice-web-app/shared-types';
import { FC } from 'react';
import { DsIcon } from '../../../../components/icons/DsIcon';
import { MenuItem } from '../../../@menu/vertical-menu';

interface Props {
  menu: SidebarMenuItem;
  menuIndex: number;
  addSidebarMode: boolean;
  selectedSidebar: SidebarMenuItem[];
  toggleSelectSidebar: (menu: SidebarMenuItem) => void;
}
const VerticalMenuItems: FC<Props> = ({ menu, addSidebarMode, menuIndex, selectedSidebar, toggleSelectSidebar }) => {
  return (
    <MenuItem
      href={menu.path}
      icon={menu.icon}
      key={menuIndex}
      badge={menu.badge}
      permissions={menu.permissions}
      disabled={menu.disabled}
      {...(addSidebarMode && {
        suffix: (
          <DsIcon
            icon={
              selectedSidebar.find((menuItem) => menuItem.path === menu.path)
                ? localStorage.getItem('MY_SIDEBAR') === 'true'
                  ? 'MINUS_IN_FRAME'
                  : 'PLUS_IN_FRAME_FILL'
                : localStorage.getItem('MY_SIDEBAR') === 'true'
                  ? 'MINUS_FILL'
                  : 'PLUS_IN_FRAME'
            }
            color={localStorage.getItem('MY_SIDEBAR') === 'true' ? 'error.500' : 'primary.500'}
          />
        ),
        suffixOnClick: () => toggleSelectSidebar(menu),
      })}
    >
      {menu.title}
    </MenuItem>
  );
};
export default VerticalMenuItems;
